import React, { Component } from 'react';
import __ from 'lodash';
import { Bar } from 'react-chartjs-2';

class GraphKomparasiSkorCabang extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapel: {},
            labels: [],
            datasets: []
        }
    }

    componentDidMount() { 
        let array = [], labels = [];
        if(!__.isEmpty(this.props.dataProvinsi)) {  
            this.setState({ mapel: this.props.dataDinas.namaMataPelajaran })

            let dataKategCab = [];
            this.props.dataDinas.kategories.map(cab => {
                dataKategCab.push(cab.persen);
                labels.push(cab.kategori);
            })            
            let objectCab = {'label': 'CabDindik', 'data': dataKategCab, 'backgroundColor': 'rgb(54, 162, 235)'}             
            array.push(objectCab)

            let dataKategProv = [];
            this.props.dataProvinsi.map(prov => {
                dataKategProv.push(prov.persen);                
            }) 
            let objectProv = {'label': 'Provinsi', 'data': dataKategProv, 'backgroundColor': 'rgb(255, 99, 132)'}             
            array.push(objectProv)            
        }
        this.setState({ datasets: array, labels: labels})
    }


    render() {        
        const data = {
        labels: this.state.labels,
        datasets: this.state.datasets,
        }
        const options = {
            legend: { 
                position: 'bottom' 
            },
            title: {
                display: true,
                text: this.state.mapel + ' (dalam %)'
            } ,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    stacked: true,
                    steps: 10,
                    max: 100
                  },
                },
              ],
              xAxes: [
                {
                    display: false,
                }
              ]
            },
            responsive: false,
            maintainAspectRatio: true,
        }
        return(
            <Bar data={data} options={options} width={460} height={320} />
        )
    }

}

export default GraphKomparasiSkorCabang;